<template>
    <v-dialog v-model="dialog" width="600">
      <v-card>
        <v-card-title class="headline">
          Dodaj mapę
        </v-card-title>
        <v-card-text>
          <v-form
              ref="newForm"
              v-model="valid"
              lazy-validation
              class="dimension--form mt-5 mb-5"
          >
            <v-row>
              <v-col cols="12" md="12" align-self="start" dense>
                <v-text-field
                    v-model="form.name"
                    :rules="formRules.name"
                    class="pt-0"
                    type="url"
                    label="Nazwa"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12" align-self="start" dense>
                <v-textarea
                    v-model="form.code"
                    :rules="formRules.code"
                    class="pt-2"
                    type="url"
                    label="Kod mapy"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  @click.prevent="onSubmit"
                  type="Submit"
                  class="action-btn--green-gradient place-btn wastemaster-action-btn text-none"
                  large
              >Dodaj&nbsp;<v-icon size="24">mdi-send</v-icon></v-btn
              >
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
</template>

<script>

import api from "@/services/api";

export default {
  name: 'ModalAddMap',
  props: {
    item: {},
  },
  mixins: [
  ],
  created() {
  },
  data() {
    return {
      dialog: false,
      form: {
        name: '',
        code: '',
      },
      formRules: {
        name: [(value) => !!value || 'Wpisz nazwę mapy'],
        code: [(value) => !!value || 'Wpisz kod mapy'],
      },
      valid: false,
    }
  },
  methods: {
    open() {
      this.dialog = true
    },
    async onSubmit() {
      if (!this.$refs.newForm.validate()) {
        return
      }

      const map = {
        name: this.form.name,
        code: this.form.code,
      }
      api
          .post('/api/maps' , map)
          .then(() => {
            this.$root.$emit('notifySuccess', {
              html: 'Mapa została dodana.',
            });
            this.dialog = false;
            this.form.from = '';
            this.form.to = '';
            this.$parent.getMaps();
          })
          .catch((error) => {
            console.error('Error when adding a redirect:', error);
            this.$root.$emit('notifyError', {
              html: 'Wystąpił błąd.',
            });
          })
    },
  },
}
</script>

<style scoped></style>
